import React from 'react'

import styles from './formItemsInlineGroup.module.scss'

const FormItemsInlineGroup = props => {
  return (
    <div className={styles.container_formItemsInlineGroup}>
      {
        props.children.map((item, index) => {
          return (
            <div className={styles.container_formItemInlineGroupItem} key={index}>
              {item}
            </div>
          )
        })
      }
    </div>
  )
}

export default FormItemsInlineGroup